export default "__VITE_ASSET__nXst7Gek__"